module.exports = __webpack_public_path__ + "media/images/flags/bm-e2aa572a02963b087e48158ff3de2fcc.svg";